import SiteHeader from './components/SiteHeader';
import HeroSection from './components/HeroSection';
import SynopsisSection from './components/SynopsisSection';
import EpisodeSection from './components/EpisodeSection';
import CastSection from './components/CastSection';
import StillsSection from './components/StillsSection';
import HighlightSection from './components/HighlightSection';
import ReviewSection from './components/ReviewSection';
import FaqSection from './components/FaqSection';
import RecommendSection from './components/RecommendSection';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteHeader />
      <main>
        <HeroSection />
        <SynopsisSection />
        <EpisodeSection />
        <CastSection />
        <StillsSection />
        <HighlightSection />
        <ReviewSection />
        <FaqSection />
        <RecommendSection />
      </main>
      <SiteFooter />
    </div>
  );
}